// export const server = `https://staging-manage.picosa.com.my/api/ap/`; //staging
export const server = `https://manage.picosa.com.my/api/ap/`; //production
// export const server = `http://picosa-api.localhost/api/ap/`;

export const requestAuthOption = (formData) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (formData) {
        const requestOptions = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`, // ✅ keep the token
                // ❌ don't set 'Content-Type' here
            },
            body: formData,
        };
        return requestOptions
    }
}
